// extracted by mini-css-extract-plugin
module.exports = {"custom-y-axis-tick":"styles_custom-y-axis-tick__1Ppd9","placeHolderShimmer":"styles_placeHolderShimmer__1NkZB","shimmer":"styles_shimmer__F2I3s"};